import React from 'react'

import styles from './header-mobile.module.scss'

interface HeaderMobileTitleProps {
    title: string
}

export const HeaderMobileTitle: React.FC<HeaderMobileTitleProps> = ({ title }) => {
    return <h1 className={styles['header-mobile__title']}>{title}</h1>
}
